import { useRef, useEffect, useState } from "react";
import { ReactComponent as ChevronDown } from "../../../../assets/icons/chevron-down.svg";
import { twMerge } from "tailwind-merge";

export const getFinalStatusOptions = (certificationAssets: any) => {
  return Object.keys(certificationAssets?.userStatus || {})
  .filter((status) => ["passed", "failed"].includes(status))
  .map((status) => ({
    label: certificationAssets?.userStatus?.[status]?.label,
    value: status,
    backgroundColor: certificationAssets?.userStatus?.[status]?.backgroundColor,
    textColor: certificationAssets?.userStatus?.[status]?.textColor,
  }));
};

export function StatusInputSelect({
  value,
  onChange,
  certificationAssets,
  className,
}: {
  value: string;
  onChange: (value: string) => void;
  certificationAssets?: any;
  className?: string;
}) {
  const [show, setShow] = useState(false);
  const selectedOption = certificationAssets?.userStatus?.[value] || certificationAssets?.userStatus?.pending;
  const containerRef = useRef(null);

  useEffect(() => {
    // Implement outside click handler
    function handleClickOutside(event: MouseEvent) {
      if (
        containerRef.current &&
        !(containerRef.current as HTMLElement).contains(event.target as Node)
      ) {
        setShow(false);
      }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative w-fit" ref={containerRef} onClick={(e) => e.stopPropagation()}>
      <button
        onClick={() => setShow(!show)}
        className={twMerge("w-full h-[30px] flex items-center gap-1 justify-between rounded-[5px] px-4 bg-[#959595]", className)}
        style={{
            backgroundColor: selectedOption?.backgroundColor,
          }}
      >
        <div className="text-center font-medium text-[11px]" style={{ color: selectedOption?.textColor }}>
          {selectedOption?.label || "Select Status"}
        </div>
        <ChevronDown className={`${show ? "rotate-[180deg]" : ""} w-4 h-4`} />
      </button>
      {show && (
        <div className="absolute z-[2] -top-4 left-0 w-full bg-white shadow-lg rounded-lg flex flex-col">
          {getFinalStatusOptions(certificationAssets)?.map((opt) => (
            <button
              onClick={() => {
                onChange(opt.value);
                setShow(false);
              }}
              className="h-[30px] text-black flex items-center font-medium justify-center hover:bg-gray-100 text-[11px]"
            >
              {opt.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
